/**
 * A property that contains the library <a href="http://semver.org/">semantic version number</a>.
 * @name version
 * @static
 * @since 1.0.0
 * @memberOf Util
 * @type string
 * @example
 * as.version
 * // => '1.1.0'
 */
const version = '1.1.0';

export default version;